import { jsx as o } from "react/jsx-runtime";
import "react";
import { EqualSizeFlexRow as i } from "../EqualSizeFlexRow/EqualSizeFlexRow.js";
function n({ children: r, gap: t = "1.5rem" }) {
  return /* @__PURE__ */ o("promotions-row-block", { children: /* @__PURE__ */ o(i, { gap: t, children: r }) });
}
export {
  n as PromotionsRowBlock,
  n as default
};
